interface CardNameInput {
  name: string;
  printedName?: string | null;
  flavorName?: string | null;
  lang?: string | null;
}

interface AltNames {
  primary: string | null;
  secondary: string | null;
}

export function pickAltNames(card: CardNameInput): AltNames {
  const flavor = card.flavorName && card.flavorName !== card.name ? card.flavorName : null;
  const printed =
    card.printedName && card.printedName !== card.name && card.printedName !== flavor
      ? card.printedName
      : null;

  if (card.lang && card.lang !== 'en' && printed) {
    return { primary: printed, secondary: flavor };
  }
  if (flavor) {
    return { primary: flavor, secondary: printed };
  }
  if (printed) {
    return { primary: printed, secondary: null };
  }
  return { primary: null, secondary: null };
}
